module.exports = __webpack_public_path__ + "static/MAKE_YOUR_LIFE-fd5159467bd3c72d4c3be6687169f5d7.png";